import { useEffect, useState } from "react";
import { matchPath, useNavigate, useLocation } from 'react-router-dom';

import { useTranslation } from "react-i18next";

import { IconButton, Box, Drawer, useTheme, Typography } from "@mui/material";

import BackIcon from "../../../icons/BackIcon";
import CubeIcon from "../../../icons/CubeIcon";
import CubesIcon from "../../../icons/CubesIcon";

import DrawerHeader from "../../../styled/DrawerHeader";
import apiClient from "../../../../services/api";
import { toggleMessageOpen } from "../../../../store/actions/Message";
import store from "../../../../store";
import mainFont from "../../../../fonts/RobotoCondensed-Regular.ttf";
import FloorPlanPublicView2D from "./FloorPlanPublicView2D";
import FloorPlanPublicView3D from "./FloorPlanPublicView3D";
import Main from "../../../styled/Main";
import FloorPlanPublicViewSidebar from "./FloorPlanPublicViewSidebar";
import { ThemeToggle } from "../../../partials/CustomToggle";
import StyledIconButton from "../../../partials/easyFloor/StyledIconButton";
import { useSelector } from "react-redux";
import { Article } from "@mui/icons-material";

import { setSideBarIsOpened } from "../../../../store/actions/Store";

const drawerWidth = 500;
const fonts = [mainFont];

function FloorPlanPublicView({type})
{
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const urlParams = window.location.href.split('/');
    const token = urlParams.at(-1);
    const is3D = matchPath({ path: '/public/easy-floor/view-3d/' + token, end: true }, location.pathname);

    const [storeData, setStoreData] = useState(null);
    const [selectedElement, setSelectedElement] = useState(null);

    const open = useSelector((state) => state.store.sideBarIsOpened);

    useEffect(() => {
        store.dispatch(setSideBarIsOpened(false));
    }, []);

    useEffect(() => {
        apiClient.post('/api/easy-floor/load-public', {token: token}).then(response => {
            if(!response.data.success) {
                return;
            }

            setStoreData(response.data);

        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while selecting project'), "error"));
        });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const handleChangeViewType = () => {
        if(is3D) {
            navigate('/public/easy-floor/view/' + token);
        } else {
            navigate('/public/easy-floor/view-3d/' + token);
        }
    }

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        padding: '20px'
                    },
                    padding: '0px',
                    borderLeft: '1px solid ' + theme.palette.storeDrawer.borderLeft.color
                }}
                variant="persistent"
                anchor="left"
                open={open}
                PaperProps={{ sx: {
                    padding: '0px',
                    position: "relative",
                    backgroundColor: theme.palette.storeDrawer.background
                }}}
            >
                <DrawerHeader>
                    <Typography>
                        {(storeData && storeData.floor_plan) && storeData.floor_plan.name}
                    </Typography>
                    <button
                        type="button"
                        onClick={() => { store.dispatch(setSideBarIsOpened(open ? false : true)); }}
                        style={{
                            //display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            padding: '0px',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        <BackIcon />
                    </button>
                </DrawerHeader>
                <FloorPlanPublicViewSidebar storeData={storeData} selectedElement={selectedElement} setSelectedElement={setSelectedElement} />
            </Drawer>
            <Main open={open} drawerWidth={drawerWidth}>
                <div style={{position: 'absolute', left: '10px', bottom: '10px', color: 'red', zIndex: 9999}}>
                    <ThemeToggle />
                </div>
                <div style={{ position: 'absolute', top: '50%', right: '20px', zIndex: 10, transform: 'translateY(-50%)' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <StyledIconButton
                            color="primary"
                            title={t('Change View')}
                            isActive={false}
                            onClick={handleChangeViewType}
                            theme={theme}
                        >
                            {!is3D ? <CubeIcon /> : <CubesIcon />}
                        </StyledIconButton>
                        <StyledIconButton
                            color="primary"
                            title={t('Show report')}
                            isActive={open}
                            onClick={() => {
                                store.dispatch(setSideBarIsOpened(open ? false : true));
                            }}
                        >
                            <Article />
                        </StyledIconButton>
                    </div>
                </div>
                {storeData && (type === '2D' 
                    ? <FloorPlanPublicView2D
                        storeData={storeData}
                        selectedElement={selectedElement}
                        setSelectedElement={setSelectedElement}
                    />
                    : <FloorPlanPublicView3D storeData={storeData} />)}
            </Main>
        </Box>
    );
}

export default FloorPlanPublicView;